<template>
  <div class="authenticated">
    <div class="nav-bg container-fluid">
      <navigation></navigation>
    </div>
    <div class="container">
      <div class="application-content">
        <alert v-if="isError" type="danger"/>
        <alert v-if="isMessage" type="primary"/>
        <h1 class="gradient">Dashboard</h1>
        <adminDashboard v-if="isAdmin"/>
        <svDashboard v-else/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import Alert from '@/components/Alert'
  import Nav from '@/components/Nav'
  import svDashboard from '@/components/SvDashboard'
  import adminDashboard from '@/components/admin/Dashboard'

  export default {
    name: 'Dashboard',
    data () {
      return {
        appBtnDisabled: false
      }
    },
    computed: {
      ...mapGetters(['isError', 'isMessage']),
      ...mapState('user', ['isAdmin'])
    },
    components: {
      alert: Alert,
      navigation: Nav,
      svDashboard: svDashboard,
      adminDashboard: adminDashboard
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue